import { render, staticRenderFns } from "./huovKopieHogs.vue?vue&type=template&id=143dcc11&scoped=true"
import script from "./huovKopieHogs.vue?vue&type=script&lang=js"
export * from "./huovKopieHogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143dcc11",
  null
  
)

export default component.exports